import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { Box, Container } from "@mui/material";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";

import { ProfileData } from "./ProfileData";
import { callMsGraph } from "../../services/graph";
import { loginRequest } from "../../services/authConfig";
import CustomerService from "../../services/customerService";
import { Header } from "../common/Header";
import { TopBar } from "../common/TopBar";
import { ProfileSkeleton } from "../common/Skeletons";
import { EmptyState } from "../common/EmptyState";

export const ProfileContent = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [customerLoaded, setCustomerLoaded] = useState(false);

  useEffect(() => {
    if (accounts.length > 0) {
      instance
        .acquireTokenSilent({ ...loginRequest, account: accounts[0] })
        .then((response) =>
          callMsGraph(response.accessToken).then((resp) => setGraphData(resp))
        )
        .catch(() => {});
    }
    const customerService = CustomerService();
    customerService
      .getCustomer()
      .then((response) => setCustomerData(response))
      .catch(() => {})
      .finally(() => setCustomerLoaded(true));
  }, [accounts]);

  const isLoading = !graphData || !customerLoaded;

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <Header />
      <TopBar />
      <Container maxWidth="lg" sx={{ py: 3 }}>
        {isLoading ? (
          <ProfileSkeleton />
        ) : !customerData ? (
          <EmptyState
            icon={<PersonOffOutlinedIcon />}
            title="Profile not available"
            description="We couldn't load your customer profile right now. Please try again in a moment or contact your account manager."
          />
        ) : (
          <ProfileData graphData={graphData} customerData={customerData} />
        )}
      </Container>
    </Box>
  );
};
